import { render, staticRenderFns } from "./RoutingPeerGroupForm.vue?vue&type=template&id=9ac97bd4&"
import script from "./RoutingPeerGroupForm.vue?vue&type=script&lang=js&"
export * from "./RoutingPeerGroupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports